<div class="card" *ngIf="model.id">
    <div class="card-body">
        <div *ngIf="model.network">
            <p>{{ 'offers.form.recipient.network' | translate }}</p>
            <div class="selector-list">
                <div class="selector-list-item">
                    <div class="selector-list-image">
                        <img [src]="model.network.logo | imageFromApi" alt="Network logo">
                    </div>
                    <div class="selector-list-name">
                        {{ model.network.name }}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!model.network && !model.stores.length">
            <p>{{ 'offers.form.recipient.brand' | translate }}</p>
            <div class="selector-list">
                <div class="selector-list-item">
                    <div class="selector-list-image">
                        <img [src]="model.brand.logo | imageFromApi" alt="Brand logo">
                    </div>
                    <div class="selector-list-name">
                        {{ model.brand.name }}
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="model.stores.length">
            <p>{{ 'offers.form.recipient.stores' | translate }}</p>
            <table class="table table-stripped table-bordered">
                <thead>
                    <tr>
                        <th>{{ 'shared.table.name' | translate }}</th>
                        <th>{{ 'shared.table.merchant' | translate }}</th>
                        <th>{{ 'shared.table.zipcode' | translate }}</th>
                        <th>{{ 'shared.table.city' | translate }}</th>
                        <th>{{ 'shared.label.company_number' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let store of model.stores">
                        <td>{{ store.name }}</td>
                        <td>{{ store.merchant?.name || '-' }}</td>
                        <td>{{ store.zip_code }}</td>
                        <td>{{ store.city | uppercase }}</td>
                        <td>{{ store.siret | serial }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
